import { Box, Card, CardActionArea, Chip, Stack, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { formatEducationLevel, sortEducationLevels } from '../../utils/educationLevels';

import type { CspStandardSet } from '@/shared/types/userStandard';

interface StandardSetCardsProps {
  sets: CspStandardSet[];
  onPick: (set: CspStandardSet) => void;
}

export function StandardSetCards({ sets, onPick }: StandardSetCardsProps) {
  return (
    <Box sx={{ p: 2.5, height: '100%', overflow: 'auto' }}>
      <Typography variant="overline" color="text.secondary">
        {sets.length} standard set{sets.length === 1 ? '' : 's'}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 1.5,
          mt: 1,
        }}
      >
        {sets.map((set) => {
          const grades = sortEducationLevels(set.education_levels).map(formatEducationLevel);
          const deprecated = set.document_publication_status === 'Deprecated';
          return (
            <Card key={set.id} variant="outlined">
              <CardActionArea onClick={() => onPick(set)} sx={{ p: 2 }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                      {set.title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {set.subject}
                    </Typography>
                    <Stack direction="row" spacing={0.5} sx={{ mt: 1, flexWrap: 'wrap', gap: 0.5 }}>
                      {grades.map((g) => (
                        <Chip key={g} label={g} size="small" variant="outlined" />
                      ))}
                      {deprecated && (
                        <Chip label="Deprecated" size="small" color="warning" variant="outlined" />
                      )}
                    </Stack>
                  </Box>
                  <ChevronRightIcon color="action" />
                </Stack>
              </CardActionArea>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
}

export default StandardSetCards;
